/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import Donation from '../../interfaces/Donation';
import DonationCurrency from '../../interfaces/DonationCurrency';
import { RemoteData, RemoteError, RemoteStatus } from '../SharedTypes';
import { fetchButton, fetchCurrencies } from './DonationThunks';

export enum DonationStage {
	None = 0,
	CurrencySelect = 1,
	Donate = 2,
}

type PublicFormState = {
	button: RemoteData<Donation>;
	currencies: RemoteData<DonationCurrency[]>;
};

const initialState: PublicFormState = {
	button: {
		status: RemoteStatus.None,
	},
	currencies: {
		status: RemoteStatus.None,
	},
};

const slice = createSlice({
	initialState,
	name: 'donation',
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(fetchButton.pending, (state) => {
				state.button.status = RemoteStatus.InProgress;
				delete state.button.error;
			})
			.addCase(fetchButton.rejected, (state, { payload }) => {
				state.button.status = RemoteStatus.Error;
				state.button.error = payload as RemoteError;
			})
			.addCase(fetchButton.fulfilled, (state, { payload }) => {
				state.button.status = RemoteStatus.Done;
				state.button.data = payload;
			})
			.addCase(fetchCurrencies.pending, (state) => {
				state.currencies.status = RemoteStatus.InProgress;
				delete state.currencies.error;
			})
			.addCase(fetchCurrencies.rejected, (state, { payload }) => {
				state.currencies.status = RemoteStatus.Error;
				state.currencies.error = payload as RemoteError;
			})
			.addCase(fetchCurrencies.fulfilled, (state, { payload }) => {
				state.currencies.status = RemoteStatus.Done;
				state.currencies.data = payload;
			}),
});

export default slice;
